type SplitOptions = { capitalize?: boolean };

export const splitSnakeCase = (
  str: string | null | undefined,
  options: SplitOptions = {}
) => {
  if (!str) return '';

  const result = str.replace(/_/g, ' ');

  if (options.capitalize) {
    return result
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  return result;
};
